<template>
  <modal
    name="default-filters-modal"
    adaptive
    scrollable
    height="auto"
  >
    <div class="p-5">
      <div class="flex justify-between border-b border-sc-gray-light">
        <div class="text-xl">
          {{ $t('message.settings.filtersTab.createFilter') }}
        </div>
        <button
          @click="hide()"
        >
          <img
            :src="require('@assets/images/cross.svg')"
            class="self-center h-5 p-1 ml-1"
            alt="cerrar"
          >
        </button>
      </div>
      <div class="flex flex-wrap items-center py-4 border-b border-sc-gray-light">
        <p class="mr-2 text-l">
          {{ $t('message.settings.filtersTab.filterName') }}
        </p>
        <div class="flex p-2 space-x-2 border rounded shadow md:h-8">
          <input
            type="text"
            name="default-filter-name"
            id="default-filter-name"
            v-model="name"
            :placeholder="$t('message.settings.filtersTab.addFilterName')"
            class="w-64 text-xs focus:outline-none"
          >
        </div>
      </div>
      <filters-selector
        :accounts-filter="accountsFilter"
        :post-date-filter="postDateFilter"
        :institution-filter="institutionFilter"
        :from-amount-filter="fromAmountFilter"
        :to-amount-filter="toAmountFilter"
        :inbound-filter="inboundFilter"
        :outbound-filter="outboundFilter"
        :status-filter="statusFilter"
        :type-filter="typeFilter"
        @filterChanged="changeFilterValue"
        @clearCurrentPostDateFilter="clearCurrentPostDateFilter"
        @clearCurrentAmountFilter="clearCurrentAmountFilter"
        @selectAllAccounts="selectAllAccounts"
        @changeAccountFilter="changeAccountFilter"
      />
      <div class="flex justify-end text-xl border-t h-36 border-sc-gray-light">
        <button
          class="inline-block h-8 px-3 py-1 mt-2 mr-4 text-sm leading-5 text-center text-white rounded bg-sc-blue hover:text-white"
          @click="saveFilter"
        >
          {{ $t('message.settings.filtersTab.saveFilter') }}
        </button>
      </div>
    </div>
  </modal>
</template>
<script>

import keyBy from 'lodash/keyBy';
import mapValues from 'lodash/mapValues';
import FiltersSelector from './filters-selector.vue';

export default {
  data() {
    return {
      name: undefined,
      paramNames: {
        accountsFilter: 'accounts',
        postDateFilter: 'post_date',
        institutionFilter: 'institution',
        fromAmountFilter: 'from',
        toAmountFilter: 'to',
        inboundFilter: 'inbound',
        outboundFilter: 'outbound',
        statusFilter: 'status',
        typeFilter: 'movement_type',
      },
      accountsFilter: {},
      postDateFilter: [],
      institutionFilter: 'all',
      fromAmountFilter: undefined,
      toAmountFilter: undefined,
      inboundFilter: true,
      outboundFilter: true,
      statusFilter: undefined,
      typeFilter: undefined,
    };
  },
  components: {
    FiltersSelector,
  },
  props: {
    entityId: {
      type: Number,
      required: true,
    },
    accounts: {
      type: Array,
      required: true,
    },
  },
  methods: {
    show() {
      this.$modal.show('default-filters-modal');
    },
    hide() {
      this.$modal.hide('default-filters-modal');
    },
    saveFilter() {
      const filterParams = this.getFilterParams();
      this.$emit('add-default-filter', filterParams);
      this.hide();
    },
    addValidPostDateFilter(param, filterParams) {
      if (this[param].length > 0) {
        filterParams[this.paramNames[param]] = this[param];
      }
    },
    addValidInboundOrOutboundFilter(param, filterParams) {
      if (this[param] === false) {
        filterParams[this.paramNames[param]] = this[param];
      }
    },
    addValidAccountsFilter(param, filterParams) {
      if (this.activeAccounts.length > 0) {
        if (this.activeAccounts[0] === 'null' || this.activeAccounts.length !== this.accountsLength) {
          filterParams[this.paramNames[param]] = this.activeAccounts;
        }
      }
    },
    getFilterParams() {
      const filterParams = { name: this.name };
      Object.keys(this.paramNames).forEach(param => {
        if (param === 'postDateFilter') {
          this.addValidPostDateFilter(param, filterParams);
        } else if (param === 'inboundFilter' || param === 'outboundFilter') {
          this.addValidInboundOrOutboundFilter(param, filterParams);
        } else if (param === 'accountsFilter') {
          this.addValidAccountsFilter(param, filterParams);
        } else {
          if (this[param] && this[param] !== 'all') {
            filterParams[this.paramNames[param]] = this[param];
          }
        }
      });

      return filterParams;
    },
    changeFilterValue(filterData) {
      this[filterData.filterName] = filterData.filterValue;
    },
    clearCurrentPostDateFilter() {
      this.postDateFilter = [];
    },
    clearCurrentAmountFilter() {
      this.fromAmountFilter = undefined;
      this.toAmountFilter = undefined;
    },
    selectAllAccounts(value) {
      Object.keys(this.accountsFilter).forEach(key => {
        if (this.accountsFilter[key].selected !== value) {
          this.accountsFilter[key].selected = !this.accountsFilter[key].selected;
        }
      });
    },
    changeAccountFilter(accountId) {
      this.accountsFilter[accountId].selected = !this.accountsFilter[accountId].selected;
    },
    loadAccounts() {
      this.accountsFilter = mapValues(
        keyBy(this.accounts.filter((account) => account.isActive), 'id'),
        (account) => ({
          selected: true,
          customName: account.customName,
          number: account.number,
          type: account.accountType,
          institution: account.institution,
          fintocRefreshedAt: account.fintocRefreshedAt,
        }),
      );
    },
  },
  beforeMount() {
    this.loadAccounts();
  },
  computed: {
    activeAccounts() {
      const activeAccounts = Object.keys(this.accountsFilter).filter(key => (this.accountsFilter[key].selected));

      if (Object.keys(this.accountsFilter).length === 0) {
        return activeAccounts;
      }

      return activeAccounts.length === 0 ? ['null'] : activeAccounts;
    },
    accountsLength() {
      return Object.keys(this.accountsFilter).length;
    },
  },
};
</script>
<style>
@media screen and (max-width: 768px) {
  .vm--overlay[data-modal="default-filters-modal"] + .vm--modal {
    top: 0px !important;
  }
}
</style>
